import { get } from '../utils/PolyfillLodash'
import getHookLogicProductAdData from './GetHookLogicProductAdData'

const extractDetailAttributes = (included, prodAttr, k, match) => {
  if (included.attributes.title === match) {
    prodAttr.detailAttributes[k] = { name: included.attributes.title, value: included.attributes.value }
    return true
  }
  return false
}

const mergePdpDataToHookLogic = params => {
  const hlResBody = get(params, 'response.body')
  const hlResSearchProductAd = get(params, 'response.body.SearchProductAd')
  const searchProductAd = []
  const prodAttrBySKU = {}
  let hlData = {}
  let partNumber

  if (hlResBody && hlResSearchProductAd && Array.isArray(hlResSearchProductAd) && hlResSearchProductAd.length > 0) {
    const partNumbers = []
    get(params, 'pdpResponse.data', []).forEach((v, k) => {
      partNumber = v.attributes.partNumber
      partNumbers.push(partNumber)
      prodAttrBySKU[partNumber] = {
        ProductName: v.attributes.name,
        ProductSKU: partNumber,
        shipping: v.attributes.deliveryPrice,
        deliverable: v.attributes.deliverable,
        brand: v.attributes.brand,
        detailAttributes: null
      }
    })
    if (params.pdpResponse.included !== undefined) {
      get(params, 'pdpResponse.included', []).forEach((v, k) => {
        if (v.type === 'prices') {
          prodAttrBySKU[v.id].Price = v.attributes.now
          prodAttrBySKU[v.id].ComparePrice = v.attributes.was
          prodAttrBySKU[v.id].PromoText = v.attributes.flashText
        }
        if (v.type === 'reviewstatistics') {
          prodAttrBySKU[v.id].avgRating = v.attributes.avgRating
          prodAttrBySKU[v.id].reviewsCount = v.attributes.reviewCount
        }
      })
      let i = params.pdpResponse.included.length - 1
      for (let j = 0; j < partNumbers.length; j++) {
        let foundSize = false
        let foundCapacity = false
        let foundMaxSpin = false
        let foundNoOfProgrammes = false
        prodAttrBySKU[partNumbers[j]].detailAttributes = []
        for (; i >= 0; i--) {
          if (!foundSize)
            foundSize = extractDetailAttributes(
              params.pdpResponse.included[i],
              prodAttrBySKU[partNumbers[j]],
              0,
              'Size (cm)'
            )
          if (!foundCapacity)
            foundCapacity = extractDetailAttributes(
              params.pdpResponse.included[i],
              prodAttrBySKU[partNumbers[j]],
              1,
              'Wash capacity (kg)'
            )
          if (!foundMaxSpin)
            foundMaxSpin = extractDetailAttributes(
              params.pdpResponse.included[i],
              prodAttrBySKU[partNumbers[j]],
              2,
              'Maximum spin speed (rpm)'
            )
          if (!foundNoOfProgrammes)
            foundNoOfProgrammes = extractDetailAttributes(
              params.pdpResponse.included[i],
              prodAttrBySKU[partNumbers[j]],
              3,
              'Number of programmes'
            )
          if (foundCapacity && foundSize && foundMaxSpin && foundNoOfProgrammes) {
            i--
            break
          }
        }
      }
    }

    get(params, 'response.body.SearchProductAd', []).forEach((v, k) => {
      if (prodAttrBySKU && typeof prodAttrBySKU[v.ProductSKU] === 'undefined') {
        return false
      }
      const hlVal = getHookLogicProductAdData(v)
      const merged = { ...hlVal, ...prodAttrBySKU[v.ProductSKU] }
      searchProductAd.push(merged)
    })
    hlData = { ...hlResBody }
    hlData.SearchProductAd = searchProductAd
  }
  return hlData
}

export default mergePdpDataToHookLogic
